import axios from 'axios';

export default {

  deleteAnEmailAutomationList({ commit }, emailAutomationListId) {
    return new Promise((resolve, reject) => {
      commit('global/setLoadingState', true, { root: true });
      return axios.delete(`ajax/email-automation-lists/${emailAutomationListId}`)
        .then((response) => {
          commit('global/setLoadingState', false, { root: true });
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });
    });
  },
};
